import React, { useState, useEffect } from "react";
import { Header } from "../0_layout/HeaderFooter";
import { Box } from "@mui/material";
import { Footer } from "../0_layout/Footer";
import { DzCourseHeader } from "../1_home/DZ_Heading";
import { CSOffering } from "../1_home2/B_OfferingCards";
import Weserve from "../1_home2/we_serve";
import { HNumbers } from '../1_home/H_Numbers';
import SwipeableTestimonialCarousel from '../1_home/E_Testimonial'
import { AboutUsHome } from '../1_home/C_AboutUsHome';
import CarouselDisplay from "./CarouselDisplay";
import Component from "./Component";
import Events from '../1_home2/Events'
import axios from 'axios'
import { useNavigate } from "react-router-dom";


export default function Layout3() {
  const [weOfferData, setWeOfferData] = useState([]);
  const navigate = useNavigate();
  const [, setUser] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      fetch(process.env.REACT_APP_API_URL + "/api/decode-token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.decoded) {
            const expiryTime = Date.now() + 60 * 60 * 1000; // 1 hour expiry

            localStorage.setItem("token", token);
            localStorage.setItem("username", data.decoded.username);
            localStorage.setItem("userId", data.decoded.id);
            localStorage.setItem("tokenExpiry", expiryTime.toString());
            setUser(data.decoded.username);
            const url = localStorage.getItem('url');
            if (url) navigate(url)
            else navigate('/user-dashboard')
            // window.history.replaceState({}, document.title, "/");

          } else {
            console.error("Token decoding failed:", data.error);
          }
        })
        .catch((err) => console.error("Error:", err));
    }
  }, [navigate]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/visitors/track`, {
      method: "POST",
    }).catch((error) => {
      console.error("Visitor tracking failed:", error);
    });
  }, []);


  // const handleLogout = () => {
  // localStorage.removeItem("token"); // Remove token
  // setUser(null);
  // window.location.href = process.env.REACT_APP_API_URL+"/auth/logout"; // Redirect to backend logout
  //};


  useEffect(() => {
    const fetchWeOfferData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/weoffer`);

        //console.log("Response Data:", response.data); // Debugging log

        // Ensure response.data is an array before filtering
        if (!Array.isArray(response.data)) {
          console.error("Unexpected API response format:", response.data);
          return; // Exit function early if data is not an array
        }

        const filteredData = response.data.filter(item => item.type !== "book" && item.isVisible === true);
        setWeOfferData(filteredData);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchWeOfferData();
  }, []);

  return (
    weOfferData.length !== 0 &&
    <>
      {/* Fixed header stays above everything */}
      <Header />

      {/* This Box handles spacing for the fixed header */}
      <Box
        sx={{
          paddingTop: '98px', // Default to 98px since showBox is undefined
          transition: 'padding-top 0.3s ease',
          width: '100%',
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >

        <Box><CarouselDisplay /></Box>

        <Box pt={6}>
          <DzCourseHeader text="Computer Science Textbook Offerings" color="grey" />
          <DzCourseHeader text="SuperComputer Curriculum" />
        </Box>

        <Box sx={{ px: 4, py: 2, backgroundColor: '#F0F0F0' }}>
          <CSOffering />
        </Box>

        {/* LMS */}

        <Box pt={6}>
          <DzCourseHeader text="AI Powered LMS Offerings" color="grey" />
        </Box>

        <Component
          key={weOfferData[0]._id}
          greyBackground={true}
          data={weOfferData[0]}
        />

        <Box pt={6}>
          <DzCourseHeader text="Makers’ Space Curriculum
" color="grey" />
        </Box>

        <Component
          key={weOfferData[1]._id}
          greyBackground={false}
          data={weOfferData[1]}

        />

        <Box pt={6}>
          <DzCourseHeader text="Academic Excellence Program for Educators
" color="grey" />
        </Box>

        <Component
          key={weOfferData[2]._id}
          greyBackground={true}
          data={weOfferData[2]}

        />

        <Events multiple={false} />


        <Box sx={{ width: '100%', margin: 0, padding: 0, bgcolor: 'primary.main' }}>
          <Weserve isAdmin={false} />
        </Box>

        <Box>
          <DzCourseHeader text="We Touch" />
          <HNumbers />
        </Box>

        <Box>
          <DzCourseHeader text="We Hear" />
          <SwipeableTestimonialCarousel isAdmin={true} />
        </Box>

        <Box>
          <DzCourseHeader text="We Reach" />
          <AboutUsHome />
        </Box>

        <Box sx={{ flexShrink: 0, marginTop: 'auto' }}>
          <Footer />
        </Box>
      </Box>
      );
    </>)
}
